'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoBeer = function IoBeer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 12.5c2.7 0 5 2.3 5 5v7.5c0 2.7-2.3 5-5 5h-2.5v6.3c0 0.7-0.5 1.2-1.2 1.2h-20c-0.8 0-1.3-0.5-1.3-1.2v-17.5c-2 0-3.7-1.7-3.7-3.7v-4.3c-0.8-0.9-1.3-2-1.3-3.3 0-2.7 2.3-5 5-5 1.4 0 2.7 0.6 3.6 1.6 0.8-1 2-1.6 3.4-1.6 1 0 2.1 0.5 2.8 1.1 1-0.7 2.1-1.1 3.3-1.1 1.4 0 2.7 0.5 3.6 1.3 0.9-0.8 2-1.3 3.3-1.3 2.7 0 5 2.3 5 5 0 1.9-1.4 3.4-2.5 3.8v1.2h2.5z m-6.9 11.3c0.3 0 0.7-0.3 0.7-0.7v-3.7c0-0.3-0.4-0.6-0.7-0.6s-0.6 0.3-0.6 0.6v3.7c0 0.3 0.2 0.5 0.3 0.6 0.1 0.1 0.2 0.1 0.3 0.1z m0.6-6c0.1-0.1 0.1-0.3 0.1-0.5s-0.1-0.3-0.3-0.3-0.3-0.1-0.5-0.1-0.3 0.1-0.3 0.3-0.2 0.3-0.2 0.5 0.2 0.3 0.3 0.3 0.3 0.1 0.5 0.1 0.3-0.1 0.4-0.3z m1.3-5.3v-2.5h-1.6c-0.2 0.6-0.5 1.3-1 1.8-1 1.2-2.6 2-4.3 2-2 0-3.7-1.1-4.7-2.6-0.5 0.1-1 0.2-1.4 0.2-1 0-1.8-0.3-2.5-0.8-0.2-0.1-0.3-0.2-0.4-0.3-0.1 0.2-0.2 0.2-0.3 0.4-0.4 0.5-0.8 0.8-1.3 1.1v3.2h6.3c0-0.3 0.3-0.6 0.6-0.6s0.6 0.3 0.6 0.6h10v-2.5z m2.4-4.3c0.1-0.2 0.1-0.5 0.1-0.7 0-1.4-1.1-2.5-2.5-2.5-0.7 0-1.3 0.3-1.8 0.8-0.2 0.1-0.5 0.4-1.2 0.5h-0.7c-0.4-0.1-0.9-0.3-1.1-0.4-0.5-0.6-1.2-0.9-2.1-0.9-0.7 0-1.4 0.3-1.9 0.7l-0.6 0.6c0 0 0 0-0.1 0.1-0.2 0.2-0.5 0.4-0.8 0.4-0.4 0-0.6-0.2-0.9-0.5-0.1-0.1-0.1-0.2-0.2-0.4s-0.2-0.3-0.4-0.4-0.8-0.5-1.2-0.5c-0.8 0-1.5 0.7-2 1.2-0.5 0.7-2.1 0.7-2.7 0s-1.4-1.2-2.3-1.2c-1.4 0-2.5 1.1-2.5 2.5 0 0.2 0.1 0.4 0.1 0.5 0.1 0.8 0.5 1.4 1.2 1.7v5.4c0 0.7 0.5 1.2 1.2 1.2v-6.3c0.8 0 1.4-0.3 1.9-0.9 0.1-0.1 0.2-0.3 0.3-0.4 0 0 0.5-0.8 0.9-0.9s1.6-0.5 2.4 0.4c0.3 0.4 0.8 0.7 1.5 0.7 0.2 0 0.3-0.1 0.5-0.1 0.2-0.1 0.5-0.2 0.7-0.4 0.2-0.1 0.5-0.3 0.8-0.3 0.5 0 0.9 0.3 1.1 0.8 0 0 0.1 0.1 0.1 0.2 0 0.2 0 0.4 0.2 0.6 0.5 0.9 1.6 1.6 2.7 1.6 1 0 2-0.5 2.5-1.3 0.4-0.5 0.7-1.2 0.7-1.9s0.7-0.6 0.7-0.6h4.3c0.4 0 1 0.2 1.1 0.7z m5.1 16.8v-7.5c0-1.4-1.1-2.5-2.5-2.5h-2.5v12.5h2.5c1.4 0 2.5-1.1 2.5-2.5z m-22.5-11.9c0-0.4 0.2-0.6 0.6-0.6s0.7 0.2 0.7 0.6-0.3 0.7-0.7 0.7-0.6-0.3-0.6-0.7z m12.5 0c0-0.4 0.2-0.6 0.6-0.6s0.7 0.2 0.7 0.6-0.3 0.7-0.7 0.7-0.6-0.3-0.6-0.7z' })
        )
    );
};

exports.default = IoBeer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/beer.js
// module id = 1994
// module chunks = 0